<div class="homepage-template">
  <span [wcCxJsonLd]="snippetImages()"></span>

  <section>
    <!-- DynamicBody slot -->
    <cx-page-slot position="DynamicBody" />
  </section>

  <section>
    <!-- SEO slot -->
    <cx-page-slot position="SEO" />
  </section>
</div>
